export const Config = {
    appname: "W&W EasyContact"
};
